module.exports = __webpack_public_path__ + "img/about_02_new.6837e3fc.png";